export const comment = {
  singular: "Commentaire",
  plural: "Commentaires",
  noComment: "Aucun commentaire",
  form: {
    field: {
      placeholder: "Ajouter un commentaire...",
    },
    actions: {
      submit: "Envoyer",
      cancel: "Annuler",
    },
    successMessage: "Commentaire enregistré avec succès",
  },
};
